module.exports = __webpack_public_path__ + "img/ORGANIGRAMA-MARZO-2025.28c84ce9.png";